exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".status[data-v-0ec60a16] {\n  color: #fff !important;\n  min-width: 90px;\n  text-align: center;\n  display: block;\n  line-height: 31px;\n  font-weight: 400;\n  max-width: 90px;\n  cursor: pointer;\n}\n[data-v-0ec60a16] .dropdown-menu li {\n  cursor: pointer !important;\n}\n.no-pointer[data-v-0ec60a16] {\n  cursor: not-allowed !important;\n}\n", ""]);

// exports
